import React, { useEffect, useMemo, useState } from 'react';
import slide1 from 'assets/icons/img1.png';
import slide2 from 'assets/icons/img2.png';
import slide3 from 'assets/icons/img3.png';
import slide4 from 'assets/icons/img4.png';
import slide5 from 'assets/icons/img5.png';
import slide6 from 'assets/icons/img6.png';
import slide7 from 'assets/icons/img7.png';
import slide8 from 'assets/icons/img8.png';
import slide1plo5 from 'assets/icons/1.png';
import slide2plo5 from 'assets/icons/2.png';
import slide3plo5 from 'assets/icons/3.png';
import slide4plo5 from 'assets/icons/4.png';
import slide5plo5 from 'assets/icons/5.png';
import slide6plo5 from 'assets/icons/6.png';
import slide7plo5 from 'assets/icons/7.png';
import slide8plo5 from 'assets/icons/8.png';
import slide9plo5 from 'assets/icons/9.png';
import slide10plo5 from 'assets/icons/10.png';
import slide11plo5 from 'assets/icons/11.png';
import styles from './styles.module.scss';
import FAQSlide from '../../components/FAQSlide';
import FooterABC from '../../containers/Footer/footerABC';
import routes from '../../constants/routes';
import { textGuide } from '../../utils/MetaDecorator/meta';
import MetaDecorator from '../../utils/MetaDecorator';

const plo5slides = [
  {
    slide: slide1plo5,
    title: 'guideTitle1',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText1_1', sideContent: [] },
      {
        color: '#E9FF66',
        content: 'plo5guideText1_3',
        sideContent: [
          { main: 'plo5guideText1_3_6MAX' },
          { main: 'plo5guideText1_3_6MAX_LOW' },
          { main: 'plo5guideText1_3_6MAX_HIGH' },
          { main: 'plo5guideText1_3_6MAX_ANTE_POT' },
          { main: 'plo5guideText1_3_6MAX_ANTE_35' },
          { main: 'plo5guideText1_3_HU' },
          { main: 'plo5guideText1_3_HU_LOW' },
          { main: 'plo5guideText1_3_HU_MED' },
          { main: 'plo5guideText1_3_HU_HIGH' },
        ],
      },
      {
        color: '#E9FF66',
        content: 'plo5guideText1_4',
        sideIsFlex: true,
        sideContent: [
          { main: 'plo5guideText1_4_6MAX_LOW', secondary: ['20 - 20 bb', '50 - 50 bb', '75 - 75 bb', '100 - 100 bb'] },
          { main: 'plo5guideText1_4_6MAX_HIGH', secondary: ['20 - 20 bb', '50 - 50 bb', '75 - 75 bb', '100 - 100 bb'] },
          { main: 'plo5guideText1_4_6MAX_ANTE_POT', secondary: ['100 - 100 bb'] },
          { main: 'plo5guideText1_4_6MAX_ANTE_35', secondary: ['100 - 100 bb'] },
          { main: 'plo5guideText1_4_6HU', secondary: ['20 - 20 bb', '50 - 50 bb', '75 - 75 bb', '100 - 100 bb'] },
        ],
      },
      { color: '#E9FF66', content: 'plo5guideText1_5', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText1_6', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText1_7', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText1_8', sideContent: [] },
      { color: '#66ff88', content: 'plo5guideText1_9', sideContent: [] },
      { color: '#ff069c', content: 'plo5guideText1_10', sideContent: [{ main: 'plo5guideText1_10sub' }] },
      { color: '#ff8166', content: 'plo5guideText1_11', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText1_12', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText1_12_5', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText1_13', sideContent: [] },
    ],
  },
  {
    slide: slide2plo5,
    title: 'plo5guideTitle2',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText2_1', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText2_2', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText2_3', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText2_4', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText2_5', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText2_6', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText2_7', sideContent: [] },
    ],
  },
  {
    slide: slide3plo5,
    title: 'plo5guideTitle3',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText3_1', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText3_2', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText3_3', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText3_4', sideContent: [] },
      { color: '#ff069c', content: 'plo5guideText3_5', sideContent: [] },
      { color: '#ff069c', content: 'plo5guideText3_6', sideContent: [] },
    ],
  },
  {
    slide: slide4plo5,
    title: 'plo5guideTitle4',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText4_1', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText4_2', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText4_3', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText4_4', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText4_5', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText4_6', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText4_7', sideContent: [] },
    ],
  },
  {
    slide: slide5plo5,
    title: 'plo5guideTitle5',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText5_1', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText5_2', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText5_3', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText5_4', sideContent: [] },
      { color: '#ff069c', content: 'plo5guideText5_5', sideContent: [] },
      { color: '#ff069c', content: 'plo5guideText5_6', sideContent: [] },
    ],
  },
  {
    slide: slide6plo5,
    title: 'plo5guideTitle6',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText6_1', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText6_2', sideContent: [] },
    ],
  },
  {
    slide: slide7plo5,
    title: 'plo5guideTitle7',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText7_1', sideContent: [] },
    ],
  },
  {
    slide: slide8plo5,
    title: 'plo5guideTitle8',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText8_1', sideContent: [] },
      { color: '#ff069c', content: 'plo5guideText8_2', sideContent: [] },
      { color: '#E9FF66', content: 'plo5guideText8_3', sideContent: [] },
    ],
  },
  {
    slide: slide9plo5,
    title: 'plo5guideTitle9',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText9_1', sideContent: [] },
    ],
  },
  {
    slide: slide10plo5,
    title: 'plo5guideTitle10',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText10_1', sideContent: [] },
    ],
  },
  {
    slide: slide11plo5,
    title: 'plo5guideTitle11',
    rules: [
      { color: '#E9FF66', content: 'plo5guideText11_1', sideContent: [{ main: 'plo5guideText11_1sub' }] },
    ],
  },
];

const slides = [{
  slide: slide1,
  title: 'guideTitle1',
  // title: 'halo',
  rules: [
    { color: '#E9FF66', content: 'guideText1_1', sideContent: [] },
    {
      color: '#E9FF66',
      content: 'guideText1_2',
      sideContent: [
        { main: 'guideText1_Low' },
        { main: 'guideText1_Mid' },
        { main: 'guideText1_High' },
        { main: 'guideText1_MTT' },
        { main: 'guideText1_MTT_PLUS' },
        { main: 'guideText1_MTT_225' },
        { main: 'guideText1_HU' },
        { main: 'guideText1_HU1' },
        { main: 'guideText1_HU2' },
        { main: 'guideText1_HU3' },
        { main: 'guideText1_HU4' },
        { main: 'guideText1_Buckets' },
        { main: 'guideText1_Pll' },
        { main: 'guideText1_In' },
      ],
    },
    {
      color: '#E9FF66',
      content: 'guideText1_3',
      sideIsFlex: true,
      sideContent: [
        { main: 'guideText1_cash_game', secondary: ['30 - 30 bb', '50 - 50 bb', '100 - 100 bb', '200 - 200 bb'] },
        { main: 'guideText1_mtt', secondary: ['10 - 10 bb', '30 - 30 bb', '50 - 50 bb', '100 - 100 bb'] },
        { main: 'guideText1_mtt_225', secondary: ['10 - 10 bb', '20 - 20 bb', '30 - 30 bb', '40 - 40 bb', '50 - 50bb'] },
        { main: 'guideText1_hu', secondary: ['20 - 20 bb', '30 - 30 bb', '40 - 40 bb', '50 - 50 bb'] },
        { main: 'guideText1_hu1', secondary: ['10 - 10 bb', '20 - 20 bb', '30 - 30 bb', '40 - 40 bb', '50 - 50 bb'] },
        { main: 'guideText1_hu2', secondary: ['10 - 10 bb', '20 - 20 bb', '30 - 30 bb', '40 - 40 bb', '50 - 50 bb'] },
        { main: 'guideText1_hu3', secondary: ['20 - 20 bb', '50 - 50 bb', '100 - 100 bb', '150 - 150 bb', '200 - 200 bb'] },
      ],
    },
    {
      color: '#E9FF66',
      content: 'guideText1_4',
      sideContent: [],
    },
    {
      color: '#E9FF66',
      content: 'guideText1_5',
      sideContent: [],
    },
    { color: '#E9FF66', content: 'guideText1_6', sideContent: [] },
    { color: '#E9FF66', content: 'guideText1_7', sideContent: [] },
    { color: '#66FF88', content: 'guideText1_8', sideContent: [] },
    {
      color: '#ff069c',
      content: 'guideText1_9',
      sideContent: [{ main: 'guideText1_9_BB_situation' }],
    },
    {
      color: '#FF8266',
      content: 'guideText1_10',
      sideContent: [],
    },
    {
      color: '#E9FF66',
      content: 'guideText1_11',
      sideContent: [],
    },
    {
      color: '#E9FF66',
      content: 'guideText1_12',
      sideContent: [],
    },
    {
      color: '#E9FF66',
      content: 'guideText1_13',
      sideContent: [],
    },
  ],
}, {
  slide: slide2,
  title: 'guideTitle2',
  rules: [
    { color: '#E9FF66', content: 'guideText2_1', sideContent: [] },
    {
      color: '#FF8266',
      content: 'guideText2_2',
      sideContent: [],
    },
    {
      color: '#EA67FF',
      inDetail: routes.app.articles.tips.root,
      content: 'guideText2_3',
      sideContent: [],
    },
    {
      color: '#E9FF66',
      inDetail: routes.app.articles.tips.root,
      content: 'guideText2_4',
      sideContent: [],
    },
    {
      color: '#E9FF66',
      content: 'guideText2_5',
      sideContent: [],
    },
    { color: '#E9FF66', content: 'guideText2_6', sideContent: [] },
    { color: '#67FFED', content: 'guideText2_7', sideContent: [] },
  ],
}, {
  slide: slide3,
  title: 'guideTitle3',
  rules: [
    { color: '#E9FF66', content: 'guideText3_1', sideContent: [] },
    { color: '#E9FF66', content: 'guideText3_2', sideContent: [] },
    {
      color: '#C31AFF',
      content: 'guideText3_3',
      sideContent: [],
    },
    {
      color: '#C31AFF',
      content: 'guideText3_4',
      sideContent: [],
    },
    { color: '#000000', content: 'guideText3_5', sideContent: [] },
    {
      color: '#E9FF66', inDetail: routes.app.articles.suit.root, content: 'guideText3_6', sideContent: [],
    },
    {
      color: '#E9FF66', inDetail: routes.app.articles.suit.root, content: 'guideText3_7', sideContent: [],
    },
    {
      color: '#E9FF66', content: 'guideText3_8', sideContent: [],
    },
  ],
}, {
  title: 'guideTitle4',
  slide: slide4,
  rules: [
    { color: '#E9FF66', content: 'guideText4_1', sideContent: [] },
  ],
}, {
  title: 'guideTitle5',
  slide: slide5,
  rules: [
    { color: '#E9FF66', content: 'guideText5_1', sideContent: [] },
    { color: '#E9FF66', content: 'guideText5_2', sideContent: [] },
  ],
}, {
  title: 'guideTitle6',
  slide: slide6,
  rules: [
    {
      color: '#E9FF66',
      content: 'guideText6_1',
      sideContent: [],
    },
  ],
}, {
  title: 'guideTitle7',
  slide: slide7,
  rules: [
    {
      color: '#E9FF66',
      content: 'guideText7_1',
      sideContent: [],
    },
  ],
}, {
  title: 'guideTitle8',
  slide: slide8,
  rules: [
    {
      color: '#E9FF66',
      content: 'guideText8_1',
      sideContent: [],
    },
  ],
},
];

const PreflopFAQ = () => {
  const [isPlo5, setPlo5] = useState(sessionStorage.getItem('isPlo5') === 'true');

  useEffect(() => {
    function checkPlo5() {
      const item = sessionStorage.getItem('isPlo5');
      setPlo5(item === 'true');
    }

    window.addEventListener('storage', checkPlo5);

    return () => {
      window.removeEventListener('storage', checkPlo5);
    };
  }, []);

  const data = useMemo(() => (isPlo5 ? plo5slides : slides), [isPlo5]);

  return (
    <section className={styles.faqWrapper}>
      <MetaDecorator
        description={textGuide.description}
        title={textGuide.title}
      />
      {data.map((slide) => (
        <FAQSlide
          image={slide.slide}
          title={slide.title}
          rules={slide.rules}
        />
      ))}
      <FooterABC />
    </section>
  );
};

export default PreflopFAQ;

// const examples1 = [
//   ['Ah', 'Kh', 'Jc', '2s'],
//   ['Qd', 'Jd', '8h', '7d'],
//   ['9s', '8d', '7s', '6d'],
//   ['Jh', '9h', '8h', '7h'],
//   ['Kh', 'Ks', 'Jd', 'Tc'],
// ];
//
// const examples2 = [
//   ['8h', '8s', 'Ah', 'Kd'],
//   ['2s', '2d', 'Kd', 'Js'],
//   ['Js', 'Jh', '9h', '9d'],
//   ['5h', '5d', 'Ah', 'Kd'],
//   ['Tc', 'Ts', 'Ad', 'Qc'],
// ];
// const examples3 = [
//   ['Ah', 'Kh', 'Qc', '2s'],
//   ['As', 'Kh', 'Qh', '2c'],
//   ['Ah', 'Kh', 'Qh', '2s'],
//   ['Ac', 'Kh', 'Qh', '2h'],
// ];
//
// const examples4 = [
//   ['Ah', 'Kh', 'Qc', '2c'],
//   ['Ah', 'Kc', 'Qh', '2c'],
//   ['Ah', 'Kc', 'Qc', '2h'],
// ];
//
// const examples5 = [
//   ['Ah', 'Ks', 'Qc', '2d'],
// ];
//
// const examples6 = [
//   ['Ah', 'Kh', 'Qh', '2h'],
//   ['Ac', 'Kc', 'Qc', '2c'],
// ];
//
// const examples7 = [
//   ['9h', '9c', 'Ah', 'Kd'],
//   ['9h', '9c', 'As', 'Kh'],
//   ['9h', '9c', 'Ah', 'Kh'],
// ];
//
// const examples8 = [
//   ['9h', '9c', 'Ah', 'Kc'],
//   ['9h', '9c', 'Ac', 'Kh'],
// ];
//
// const examples9 = [
//   ['9h', '9s', 'Ac', 'Kd'],
//   ['9c', '9s', 'Ad', 'Kh'],
// ];
//
// const examples10 = [
//   ['Jh', 'Jd', '9h', '9c'],
//   ['Jh', 'Jc', '9c', '9d'],
// ];
//
// const examples11 = [
//   ['Jh', 'Jd', '9h', '9d'],
//   ['Js', 'Jc', '9c', '9s'],
// ];
//
// const examples12 = [
//   ['Jh', 'Jc', '9s', '9d'],
//   ['Jc', 'Js', '9h', '9d'],
// ];
//
// const gray1 = {
//   breakingPhrase: '+',
//   examples: ['AKJ2', 'QJ87', '9876', 'J987', 'KQJT',
//   ],
// };
//
// const gray2 = {
//   breakingPhrase: '+ две Side Cards',
//   examples: ['88AK', '22KJ', 'JJ99', '55AK', 'TTAQ',
//   ],
// };
//
// const gray3 = {
//   breakingPhrase: '+',
//   examples: ['JJ99'],
// };
//
// const gray4 = {
//   breakingPhrase: '',
//   examples: ['AKQ2'],
// };
//
// const gray5 = {
//   breakingPhrase: '',
//   examples: ['99AK'],
// };
//
// const gray6 = {
//   breakingPhrase: '',
//   examples: ['JJ99'],
// };
//
// const grayCardBuilder = (cardString, phrase) => {
//   const arr = [];
//   for (let i = 0; i < cardString.length; i += 1) {
//     arr.push(<PlayingCard value={cardString[i]} />);
//     if (i === 1) arr.push(<P>{phrase}</P>);
//   }
//   return arr;
// };

// <P>В Pot Limit Omaha существует два типа стартовых рук.</P>
// <P>- Unpaired ( стартовая рука в которой нет пары )</P>
// {examples1.map((example) => (
//   <div className={styles.exampleCards}>
//     {example.map((card) => (
//       <PlayingCard
//         suit={card[1]}
//         value={card[0]}
//       />
//     ))}
//   </div>
// ))}
// <P>
//   Заметьте, что все они расставлены от старшего номинала карты к младшей.
//   В дальнейшем нам это пригодится. По аналогии с холдемом для упрощенного понимания
//   {' '}
// </P>
// <P>можно сказать что у нас</P>
// <div className={styles.exampleCards}>
//   <PlayingCard value="A" />
//   <P>-high</P>
//   <PlayingCard value="Q" />
//   <P>-high</P>
//   <PlayingCard value="9" />
//   <P>-high</P>
//   <PlayingCard value="J" />
//   <P>-high</P>
//   <PlayingCard value="K" />
//   <P>-high на префлопе.</P>
// </div>
// {/* eslint-disable-next-line react/no-unescaped-entities */}
// <P>Но распределяются по принципу "Две High Cards" + " Две Side Cards "</P>
// {gray1.examples.map((example) => (
//   <div className={styles.exampleCards}>
//     {grayCardBuilder(example, gray1.breakingPhrase)}
//   </div>
// ))}
// <P>- Paired ( стартовая рука в которой есть хотя бы одна пара )</P>
// <P>Примеры:</P>
// {examples2.map((example) => (
//   <div className={styles.exampleCards}>
//     {example.map((card) => (
//       <PlayingCard
//         suit={card[1]}
//         value={card[0]}
//       />
//     ))}
//   </div>
// ))}
// <P>
//   В данном случае на первое место выходит старшая комбинация в руке - пара.
//   И к ней по аналогии с примерами из Unpaired добавляются две Side Cards.
//   Так же от старшей к младшей.
// </P>
// {gray2.examples.map((example) => (
//   <div className={styles.exampleCards}>
//     {grayCardBuilder(example, gray2.breakingPhrase)}
//   </div>
// ))}
// eslint-disable-next-line max-len
// <P>Если в стартовой руке есть две пары, то сначала берется так же старшая пара как основа.</P>
// <div className={styles.exampleCards}>
// <P>Как в примере</P>
// {gray3.examples.map((example) => (
// <div className={styles.exampleCards}>
// {grayCardBuilder(example, gray3.breakingPhrase)}
// </div>
// ))}
// </div>
// <P>
// Когда мы определили тип нашей стартовой руки, нам нужно посмотреть к какой Suit
// категории относится эта рука. Всего этих категорий четыре.
// </P>
// <P>Single Suited, Double Suited, Rainbow и Mono</P>
// <P>Single Suited - от двух до трех карт одной масти</P>
// <P>Double suited - Две карты одной масти + Две карты другой одинаковой масти</P>
// <P>Rainbow - Все карты разных мастей</P>
// <P>Mono - Все карты одинаковой масти</P>
// <P>Давайте разбираться подробнее.</P>
// <div className={styles.exampleCards}>
// <P>Возьмем для примера стартовую Unpaired руку</P>
// {gray4.examples.map((example) => (
// <div className={styles.exampleCards}>
// {grayCardBuilder(example, gray4.breakingPhrase)}
// </div>
// ))}
// </div>
// <P>В ней могут присутствовать от двух до четырех одинаковых мастей.</P>
// <P>Если в руке от двух до трех карт одинаковой масти это Single Suited рука.</P>
// {examples3.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <P>Если в руке две одинаковые масти + еще две одинаковой это Double Suited рука.</P>
// {examples4.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <P>Если в руке все карты разной масти это Rainbow рука.</P>
// {examples5.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <P>Если в руке все карты одной масти это Mono рука.</P>
// {examples6.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <P>
// Теперь перейдем к Paired Hands. Руки в которых есть хотя бы одна пара.
// Тут возможно всего три варианта. Single Suited  Double Suited и Rainbow
// </P>
// <div className={styles.exampleCards}>
// <P>Для примера возьмем стартовую руку</P>
// {gray5.examples.map((example) => (
// <div className={styles.exampleCards}>
// {grayCardBuilder(example, gray5.breakingPhrase)}
// </div>
// ))}
// </div>
// <P>Single Suited - от двух до трех карт одной масти</P>
// {examples7.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <P>Double suited - Две карты одной масти + Две карты другой одинаковой масти</P>
// {examples8.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <P>Rainbow - Все карты разных мастей</P>
// {examples9.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <div className={styles.exampleCards}>
// <P>Так же возьмем для примера Double Paired руку</P>
// {gray6.examples.map((example) => (
// <div className={styles.exampleCards}>
// {grayCardBuilder(example, gray6.breakingPhrase)}
// </div>
// ))}
// </div>
// <P>Single Suited - две карты одной масти ( три невозможно )</P>
// {examples10.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <P>Double suited - Две карты одной масти + Две карты другой одинаковой масти</P>
// {examples11.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <P>Rainbow - Все карты разных мастей</P>
// {examples12.map((example) => (
// <div className={styles.exampleCards}>
// {example.map((card) => (
// <PlayingCard
// suit={card[1]}
// value={card[0]}
// />
// ))}
// </div>
// ))}
// <P>Mono рука невозможна.</P>
// <img src={faq} alt="" />
